import ApplicationController from '../application_controller'

export default class extends ApplicationController {
	static targets = [
		'addIndicatorForm',
		'targetInput',
		'indicatorIdInput',
		'categoryItem',
		'indicatorSearch',
		'indicatorSearchIcon',
		'indicatorList',
		'indicatorItem',
		'indicatorSearchResultsList',
	]

	static values = { target: { type: String, default: '' } }

	connect() {
		this.sessionActivityItemTargetPath = this.targetInputTarget.value
		this.setCurrentSessionActivityIndicators()
		this.updateIndicatorItems()
	}

	updateIndicatorItems() {
		this.indicatorItemTargets.forEach(ii => this.updateIndicatorItem(ii))
	}

	selectCategory(event) {
		const selectedCategoryItem = event.currentTarget
		const showSelector = selectedCategoryItem.dataset.showSelector
		const elementToShow = document.querySelector(showSelector)

		if (elementToShow) {
			this.hideAllIndicatorLists()
			elementToShow.classList.remove('d-none')
		}

		this.inactivateAllCategoryItems()

		selectedCategoryItem.classList.add('active')
		selectedCategoryItem.classList.remove('clickable')
	}

	selectSearch(event) {
		this.hideAllIndicatorLists()
		this.inactivateAllCategoryItems()
		this.indicatorSearchResultsListTarget.classList.remove('d-none')
		this.indicatorSearchIconTarget.classList.add('bg-primary', 'text-white')
	}

	searchIndicators(event) {
		for (const searchResultElement of this.indicatorSearchResultsListTarget.querySelectorAll('li.search-result')) {
			searchResultElement.remove()
		}
		const searchInput = event.currentTarget
		const searchValue = searchInput.value.toLowerCase()
		if (searchValue.length == 0) { return }
		const matches = this.indicatorItemTargets.filter( i => i.innerText.toLowerCase().indexOf(searchValue) >= 0 )
		const emptyMessageElement = this.indicatorSearchResultsListTarget.querySelector('li.empty-message')
		for (const match of matches) {
			const newMatchElement = match.cloneNode(true)
			newMatchElement.classList.add('search-result')
			newMatchElement.dataset.listEmptyMessageTarget = 'item'
			this.indicatorSearchResultsListTarget.insertBefore(newMatchElement, emptyMessageElement)
		}
	}

	addSessionActivityIndicator(event) {
		const indicatorItem = event.currentTarget
		const indicatorId = indicatorItem.dataset.indicatorId

		this.indicatorItemTargets
			.filter(ii => ii.dataset.indicatorId == indicatorId)
			.forEach(ii => this.activateIndicatorItem(ii))

		this.targetInputTarget.value = this.sessionActivityItemTargetPath
		this.indicatorIdInputTarget.value = indicatorId
		this.addIndicatorFormTarget.action = '/sessions/add_indicator'
		this.addIndicatorFormTarget.requestSubmit()
	}

	activateIndicatorItem(indicatorItem) {
		indicatorItem.classList.add('bg-green-100')
		indicatorItem.dataset.action = 'click->app--session-activity-indicators#removeSessionActivityIndicator'

		const indicatorStatusElement = indicatorItem.querySelector('.session-activity-indicator-status')
		indicatorStatusElement.classList.remove('text-primary')
		indicatorStatusElement.classList.add('text-success')
		indicatorStatusElement.innerHTML = 'Added<div class="fa fal fa-check ms-2 me-0"></div>'
	}

	removeSessionActivityIndicator(event) {
		const indicatorItem = event.currentTarget
		const indicatorId = indicatorItem.dataset.indicatorId

		this.indicatorItemTargets
			.filter(ii => ii.dataset.indicatorId == indicatorId)
			.forEach(ii => this.inactivateIndicatorItem(ii))

		const saiList = document.querySelector(`#${this.targetValue}`)
		const liElements = Array.from(saiList.querySelectorAll('li.list-group-item'))
			.filter(liElement => !liElement.classList.contains('d-none') && !liElement.classList.contains('list-empty-message'))
		let matchingSai = null
		for (const liElement of liElements) {
			const indicatorIdElement = liElement.querySelector('input[name="session[session_activities_attributes][][session_activity_indicators_attributes][][indicator_id]"]')
			if (indicatorIdElement && indicatorIdElement.value == indicatorId) {
				matchingSai = liElement
				break
			}
		}
		if (matchingSai) {
			this.targetInputTarget.value = matchingSai.id
			this.indicatorIdInputTarget.value = indicatorId
			this.addIndicatorFormTarget.action = '/sessions/remove_indicator'
			this.addIndicatorFormTarget.requestSubmit()
		}
	}


	inactivateIndicatorItem(indicatorItem) {
		indicatorItem.classList.remove('bg-green-100')
		indicatorItem.dataset.action = 'click->app--session-activity-indicators#addSessionActivityIndicator'

		const indicatorStatusElement = indicatorItem.querySelector('.session-activity-indicator-status')
		indicatorStatusElement.classList.add('text-primary')
		indicatorStatusElement.classList.remove('text-success')
		indicatorStatusElement.innerHTML = 'Add<div class="fa fal fa-plus ms-2 me-0"></div>'
	}

	inactivateAllCategoryItems() {
		for (const categoryItem of this.categoryItemTargets) {
			categoryItem.classList.remove('active')
			categoryItem.classList.add('clickable')
		}
		this.indicatorSearchIconTarget.classList.remove('bg-primary', 'text-white')
	}

	hideAllIndicatorLists() {
		for (const list of this.indicatorListTargets) {
			list.classList.add('d-none')
		}
	}

	updateIndicatorItem(indicatorItem) {
		const itemIndicatorId = indicatorItem.dataset.indicatorId
		const existingSAI = this.currentSessionActivityIndicators.find(sai => sai.indicatorId == indicatorItem.dataset.indicatorId)
		if (existingSAI) {
			if (existingSAI.destroy == "1") { return }

			indicatorItem.dataset.target = existingSAI.target
			indicatorItem.dataset.action = 'click->app--session-activity-indicators#removeSessionActivityIndicator'
			indicatorItem.classList.remove('clickable')
			indicatorItem.classList.add('bg-green-100')
			const indicatorStatusElement = indicatorItem.querySelector('.session-activity-indicator-status')
			indicatorStatusElement.classList.remove('text-primary')
			indicatorStatusElement.classList.add('text-success')
			indicatorStatusElement.innerHTML = 'Added<div class="fa fal fa-check ms-2 me-0"></div>'
		}
	}

	setCurrentSessionActivityIndicators() {
		this.currentSessionActivityIndicators = []
		const saiList = document.querySelector(`#${this.targetValue}`)
		for (const liElement of saiList.querySelectorAll('li.list-group-item')) {
			if (liElement.classList.contains('d-none') || liElement.classList.contains('list-empty-message')) { continue }
			const sai = {}
			sai.target = liElement.id
			sai.id = liElement.querySelector('input[name="session[session_activities_attributes][][session_activity_indicators_attributes][][id]"]').value
			sai.indicatorId = liElement.querySelector('input[name="session[session_activities_attributes][][session_activity_indicators_attributes][][indicator_id]"]').value
			sai.destroy = liElement.querySelector('input[name="session[session_activities_attributes][][session_activity_indicators_attributes][][_destroy]"]').value
			this.currentSessionActivityIndicators.push(sai)
		}
	}

}

